import api from "../../lib/api";

export async function validateCoupon(code) {
  const { data } = await api.get(`/coupons/${encodeURIComponent(code)}`);
  return data;
}

export async function submitOrderRequest(order) {
  const { data } = await api.post("/order-requests", order);
  return data;
}
